// src/services/websocket.js

const BASE_URL = "wss://ws-prd.enlaparadave.com";

class WebSocketManager {
  constructor(endpointPath) {
    this.path = endpointPath;
    this.ws = null;
    this.retryTimeout = null;
    this.callbacks = new Set();
  }

  /**
   * Conecta al WebSocket usando el token del usuario.
   */
  connect(token, onOpenCallback, onCloseCallback) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) return;
    if (!token) return;

    // Pasamos el token por query param ya que los navegadores no permiten custom headers en WS
    const wsUrl = `${BASE_URL}${this.path}?token=${token}`;
    
    this.ws = new WebSocket(wsUrl);

    this.ws.onopen = () => {
      console.log(`[WS - ${this.path}] Conectado con éxito`);
      if (onOpenCallback) onOpenCallback();
      if (this.retryTimeout) clearTimeout(this.retryTimeout);
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        // Notificar a todos los suscriptores de este endpoint específico
        this.callbacks.forEach(callback => callback(data));
      } catch (error) {
        console.error(`[WS - ${this.path}] Error parseando mensaje:`, error);
      }
    };

    this.ws.onclose = () => {
      console.log(`[WS - ${this.path}] Desconectado`);
      if (onCloseCallback) onCloseCallback();
      
      // Lógica de reconexión automática
      if (token) {
        if (this.retryTimeout) clearTimeout(this.retryTimeout);
        this.retryTimeout = setTimeout(() => {
          this.connect(token, onOpenCallback, onCloseCallback);
        }, 3000);
      }
    };

    this.ws.onerror = (error) => {
      console.error(`[WS - ${this.path}] Error de socket:`, error);
      this.ws.close();
    };
  }

  /**
   * Suscribirse a los mensajes.
   * Retorna una función para desuscribirse automáticamente.
   */
  subscribe(callback) {
    this.callbacks.add(callback);
    return () => this.callbacks.delete(callback);
  }

  /**
   * Cierra la conexión manualmente y limpia recursos.
   */
  disconnect() {
    if (this.retryTimeout) clearTimeout(this.retryTimeout);
    if (this.ws) {
      this.ws.onclose = null; // Evitar disparar la reconexión
      this.ws.close();
      this.ws = null;
    }
  }
}

// 🔥 EXPORTAMOS LOS SERVICIOS DE WEBSOCKET 🔥

// 1. El original que ya tenías (Mapa / activeBuses)
export const busWebsocketService = new WebSocketManager("/employee-native-websocket/map");

// 2. El NUEVO para los tiempos estimados de las paradas (ETAs)
export const etaWebsocketService = new WebSocketManager("/employee-native-websocket/bustimeforstop");